import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';

function CreateProject() {
  const navigate = useNavigate();
  const [projectName, setProjectName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const saveProject = async () => {
    if (!projectName.trim()) {
      alert('Please enter a project name');
      return;
    }

    try {
      setIsLoading(true);
      const projectData = {
        name: projectName.trim(),
        projectValue: 0,
        labour: [],
        invoices: [],
        totalLabourCost: 0,
        totalInvoices: 0,
        totalCosts: 0,
        profit: 0,
        createdAt: new Date().toISOString()
      };

      const docRef = await addDoc(collection(db, "projects"), projectData);
      navigate(`/edit-project/${docRef.id}`, { replace: true });
    } catch (error) {
      console.error("Error saving project:", error);
      alert('Failed to save project. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '8px',
        width: '90%',
        maxWidth: '500px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <h2 style={{ marginTop: 0, marginBottom: '20px' }}>Create New Project</h2>
        
        <input
          type="text"
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
          placeholder="Enter Project Name"
          style={{
            width: '100%',
            padding: '10px',
            fontSize: '16px',
            borderRadius: '4px',
            border: '1px solid #ddd',
            marginBottom: '20px'
          }}
          autoFocus
        />

        <div style={{
          display: 'flex',
          gap: '10px',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={() => navigate('/projects')}
            style={{
              padding: '10px 20px',
              backgroundColor: '#f8f9fa',
              border: '1px solid #ddd',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            onClick={saveProject}
            disabled={isLoading || !projectName.trim()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#27ae60',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              opacity: isLoading || !projectName.trim() ? 0.7 : 1
            }}
          >
            {isLoading ? 'Creating...' : 'Create Project'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateProject;